import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tab } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 70,
        maxWidth: 70,

        opacity: 0.5,
        [theme.breakpoints.up(768)]: {
            minWidth: 150,
            maxWidth: 150,
        },
        '& span': {
            alignItems: 'normal',
        },
    },
}));

export const DraggableStageItemOverlay = (props: { label: ReactNode }) => {
    const classes = useStyles();

    return <Tab classes={classes} {...props} />;
};
